import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SiteHeader from "./components/SiteHeader/SiteHeader";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import MangoPulpPage from "./pages/mango-pulp/mango-pulp";
import GuavaPulpPage from "./pages/guava-pulp/guava-pulp";
import PineapplePulpPage from "./pages/pineapple-pulp/pineapple-pulp";
import MixedFruitPulpPage from "./pages/mixed-fruit-pulp/mixed-fruit-pulp";
import HomePage from "./pages/home/home";
import AboutUs from "./pages/AboutUs/AboutUs";
import ContactUs from "./pages/ContactUs/ContactUs";
import ContactSocialIcons from "./components/ContactSocialIcons/ContactSocialIcons";
// import BrochurePage from "./pages/brochure";
import ProductsPage from "./pages/products/products";
import AvocadoPulpPage from "./pages/avocado-pulp/avocado-pulp";
import PassionFruitPulpPage from "./pages/passion-fruit-pulp/passion-fruit-pulp";
import JackfruitPulpPage from "./pages/jackfruit-pulp/jackfruit-pulp";
import CoconutPulpPage from "./pages/coconut-pulp/coconut-pulp";
import ChikooPulpPage from "./pages/chikoo-pulp/chikoo-pulp";
import CoconutDatePulpPage from "./pages/coconut-date-pulp/coconut-date-pulp";
import SustainabilityPage from "./pages/sustainability/sustainability";
import ApplicationsPage from "./pages/applications/applications";

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <SiteHeader />
        <main>
          <Routes>
            {/* Product Routes */}
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/mango-pulp" element={<MangoPulpPage />} />
            <Route path="/products/avocado-pulp" element={<AvocadoPulpPage />} />
            <Route path="/products/guava-pulp" element={<GuavaPulpPage />} />
            <Route path="/products/pineapple-pulp" element={<PineapplePulpPage />} />
            <Route path="/products/passion-fruit-pulp" element={<PassionFruitPulpPage />} />
            <Route path="/products/jackfruit-pulp" element={<JackfruitPulpPage />} />
            <Route path="/products/coconut-pulp" element={<CoconutPulpPage />} />
            <Route path="/products/chikoo-pulp" element={<ChikooPulpPage />} />
            <Route path="/products/coconut-date-pulp" element={<CoconutDatePulpPage />} />
            <Route path="/products/mixed-fruit-pulp" element={<MixedFruitPulpPage />} />
            
            {/* Legacy Routes - Redirect to new structure */}
            <Route path="/mango-pulp" element={<MangoPulpPage />} />
            <Route path="/guava-pulp" element={<GuavaPulpPage />} />
            <Route path="/pineapple-pulp" element={<PineapplePulpPage />} />
            <Route path="/mixed-fruit-pulp" element={<MixedFruitPulpPage />} />
            
            {/* Sustainability Page */}
            <Route path="/sustainability" element={<SustainabilityPage />} />
            
            {/* Applications Page */}
            <Route path="/applications" element={<ApplicationsPage />} />
            
            {/* Other Pages */}
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            {/* <Route path="/brochure" element={<BrochurePage />} /> */}
            <Route path="/" element={<HomePage />} /> {/* Default route */}
          </Routes>
        </main>
        <ContactSocialIcons />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
